(function() {
  'use strict';

  function initPanchakarmaSlider() {
    const section = document.querySelector('.panchakarma-section');
    if (!section) return;

    const slider = section.querySelector('.panchakarma-section__slider');
    const slides = section.querySelectorAll('.panchakarma-section__slide');

    if (!slider || slides.length === 0) return;

    let currentSlide = 0;
    const totalSlides = slides.length;

    // Get or create dots container
    const mobileImages = section.querySelector('.panchakarma-section__images-mobile');
    let dotsContainer = mobileImages ? mobileImages.querySelector('.panchakarma-section__slider-dots') : null;
    /** @type {HTMLButtonElement[]} */
    const dots = [];

    // Create dots if they don't exist
    if (dotsContainer && totalSlides > 1) {
      // Clear any existing dots
      dotsContainer.innerHTML = '';
      
      for (let i = 0; i < totalSlides; i++) {
        const dot = document.createElement('button');
        dot.className = 'panchakarma-section__slider-dot';
        if (i === 0) {
          dot.classList.add('panchakarma-section__slider-dot--active');
        }
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function() {
          showSlide(i);
        });
        dotsContainer.appendChild(dot);
        dots.push(dot);
      }
    }

    // Function to update active dot
    function updateDots() {
      dots.forEach((dot, i) => {
        if (i === currentSlide) {
          dot.classList.add('panchakarma-section__slider-dot--active');
        } else {
          dot.classList.remove('panchakarma-section__slider-dot--active');
        }
      });
    }

    // Function to show a specific slide
    /**
     * @param {number} index
     */
    function showSlide(index) {
      // Ensure index is within bounds
      if (index < 0) {
        currentSlide = totalSlides - 1;
      } else if (index >= totalSlides) {
        currentSlide = 0;
      } else {
        currentSlide = index;
      }

      // Hide all slides
      slides.forEach((slide, i) => {
        const slideElement = /** @type {HTMLElement} */ (slide);
        if (i === currentSlide) {
          slideElement.style.display = 'block';
        } else {
          slideElement.style.display = 'none';
        }
      });

      // Update dots
      updateDots();
    }

    // Touch swipe and mouse drag support
    let touchStartX = 0;
    let touchEndX = 0;
    let mouseStartX = 0;
    let mouseEndX = 0;
    let isDragging = false;

    if (slider) {
      // Touch events for mobile
      slider.addEventListener('touchstart', function(e) {
        const touchEvent = /** @type {TouchEvent} */ (e);
        if (touchEvent.changedTouches && touchEvent.changedTouches[0]) {
          touchStartX = touchEvent.changedTouches[0].screenX;
        }
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        const touchEvent = /** @type {TouchEvent} */ (e);
        if (touchEvent.changedTouches && touchEvent.changedTouches[0]) {
          touchEndX = touchEvent.changedTouches[0].screenX;
          handleSwipe(touchStartX, touchEndX);
        }
      }, { passive: true });

      // Mouse events for desktop drag
      slider.addEventListener('mousedown', function(e) {
        const mouseEvent = /** @type {MouseEvent} */ (e);
        isDragging = true;
        mouseStartX = mouseEvent.clientX;
        e.preventDefault();
      }, { passive: false });

      slider.addEventListener('mousemove', function(e) {
        if (isDragging) {
          const mouseEvent = /** @type {MouseEvent} */ (e);
          mouseEndX = mouseEvent.clientX;
        }
      }, { passive: true });

      slider.addEventListener('mouseup', function() {
        if (isDragging) {
          handleSwipe(mouseStartX, mouseEndX);
          isDragging = false;
        }
      }, { passive: true });

      slider.addEventListener('mouseleave', function() {
        if (isDragging) {
          handleSwipe(mouseStartX, mouseEndX);
          isDragging = false;
        }
      }, { passive: true });
    }

    /**
     * @param {number} startX
     * @param {number} endX
     */
    function handleSwipe(startX, endX) {
      const swipeThreshold = 50; // Minimum swipe distance in pixels
      const diff = startX - endX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next slide
          showSlide(currentSlide + 1);
        } else {
          // Swipe right - previous slide
          showSlide(currentSlide - 1);
        }
      }
    }

    // Initialize first slide
    showSlide(0);

    // Handle window resize - check if we should show/hide slider
    function handleResize() {
      if (!section) return;
      
      const mobileImages = section.querySelector('.panchakarma-section__images-mobile');
      const desktopImages = section.querySelector('.panchakarma-section__images-desktop');
      
      // Only manage slider if we're in mobile view
      if (window.innerWidth < 768) {
        if (mobileImages) {
          /** @type {HTMLElement} */ (mobileImages).style.display = 'block';
        }
        if (desktopImages) {
          /** @type {HTMLElement} */ (desktopImages).style.display = 'none';
        }
      } else {
        if (mobileImages) {
          /** @type {HTMLElement} */ (mobileImages).style.display = 'none';
        }
        if (desktopImages) {
          /** @type {HTMLElement} */ (desktopImages).style.display = 'flex';
        }
      }
    }

    // Initial check
    handleResize();

    // Listen for resize events
    /** @type {number|undefined} */ let resizeTimeout;
    window.addEventListener('resize', function() {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(handleResize, 250);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPanchakarmaSlider);
  } else {
    initPanchakarmaSlider();
  }
})();

